import { render } from "./FooterAbout.vue?vue&type=template&id=1fb935e2&scoped=true"
import script from "./FooterAbout.vue?vue&type=script&lang=js"
export * from "./FooterAbout.vue?vue&type=script&lang=js"

import "./FooterAbout.vue?vue&type=style&index=0&id=1fb935e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb935e2"]])

export default __exports__